export enum TravelRegionType {
  TRAVEL_REGION_TYPE_UNKNOWN = 0,
  DOMESTIC = 1,
  INTERNATIONAL = 2,
  UNRECOGNIZED = -1,
}
